(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('HomeController', HomeController)

    /** @ngInject */
    function HomeController($rootScope, $scope, LoadingHelper, AuthenticationService, ApplicationService, ImagePathHelper, UtilHelper, DATA_EVENTS) {
        const vm = this;

        vm.getImagePath = application => {
            return ImagePathHelper.imageHandlerPath('application', application.Id, application.Image);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            LoadingHelper.startLoading('.page-content');

            const permissionGroupId = AuthenticationService.getUser().PermissionGroup.Id;

            ApplicationService
                .getAllByPermissionGroup(permissionGroupId)
                .then(success => {
                    vm.applications = success;

                    LoadingHelper.stopLoading('.page-content');
                }, error => {
                    LoadingHelper.stopLoading('.page-content');
                    UtilHelper.errorCallback(error);
                })
        }

        function init() {
            getApplications();
        }
    }
}());